import VueGoogleAutocomplete from "vue-google-autocomplete";
import { gmapApi } from "vue2-google-maps";
import AddressApi from "../../../../services/api/addressApi.js";
import Vue from "vue";

const AddressApiService = new AddressApi();

export default {
  components: {
    VueGoogleAutocomplete,
  },
  provide() {
    return { parentValidator: this.$validator };
  },

  data() {
    return {
      model: {
        first_name: "",
        last_name: "",
        company: "",
        street: "",
        apartment: "",
        city: "",
        zip_code: "",
        phone: "",
        country: "",
        state: "",
        shipping: false,
        billing: false,
        default_shipping: false,
        default_billing: false,
      },
      addressLoading: undefined,
    };
  },

  methods: {
    getAddress,
    save,
    validate,
    onAddressChanged,
  },

  computed: {
    google: gmapApi,
    modelShippingCheckbox,
    modelBillingCheckbox,
  },

  watch: {
    modelShippingCheckbox(value) {
      if (!value) {
        Vue.set(this.model, "default_shipping", false);
      }
    },
    modelBillingCheckbox(value) {
      if (!value) {
        Vue.set(this.model, "default_billing", false);
      }
    },
  },

  beforeMount() {
    if (this.$route.params.id) {
      this.getAddress();
    } else {
      this.addressLoading = false;
    }
  },
};

function getAddress() {
  this.addressLoading = true;
  AddressApiService.get(this.$route.params.id)
    .then(({ data }) => {
      this.model = data;
    })
    .catch((error) => {
      this.$swal("Attention", error.response.data.error_message);
    })
    .finally(() => {
      this.addressLoading = false;
    });
}

async function validate() {
  if (this.errors.any()) {
    return;
  }

  this.$validator.validate().then((valid) => {
    if (!valid) {
      return false;
    }

    this.save();
  });
}

function save() {
  const method = this.$route.params.id ? AddressApiService.update : AddressApiService.create,
    request = {
      ...this.model,
    };

  this.$loader.$emit("trigger", true);

  method(request)
    .then(() => {
      this.$router.push("/dashboard/addresses");
      this.$swal("Success", "Address successfully saved");
    })
    .catch((error) => {
      this.$swal("Attention", error.response.data.error_message);
    })
    .finally(() => {
      this.$loader.$emit("trigger", false);
    });
}

function modelShippingCheckbox() {
  return this.model.shipping;
}

function modelBillingCheckbox() {
  return this.model.billing;
}

function onAddressChanged(addressObject) {
  this.model = { ...this.model, ...addressObject };
}
